export default (props, vars) => props?.['applicationStatus'].company_logo;
